import "./Home.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import SystemIdentity from "./sections/SystemIdentity";
import OurCorePillars from "./sections/OurCorePillars";
import AboutMe from "./sections/AboutMe";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <AutoMotiGalvene />
      <SystemIdentity />
      <OurCorePillars />
      <AboutMe />
      <Footer />
    </div>;
}